import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const QuizOption = ({ option, isSelected, onClick }) => {
  return (
    <button
      onClick={() => onClick(option.value)}
      className={`w-full p-4 text-left border-2 rounded-lg transition-all ${
        isSelected
          ? 'border-primary bg-primary/5'
          : 'border-gray-200 hover:border-primary/50 bg-white'
      }`}
      data-testid={`quiz-option-${option.value}`}
    >
      <div className="flex items-center justify-between">
        <span className="font-medium text-gray-900">{option.label}</span>
        {isSelected && (
          <CheckCircle2 className="w-5 h-5 text-primary" />
        )}
      </div>
    </button>
  );
};
